import persianDate from "persian-date";

export function objectToFormData(obj) {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value]) => {
        formData.append(key, value);
    });
    return formData;
}

export function renameKeys(obj, newKeys) {
    const entries = Object.keys(obj).map(key => {
        const newKey = newKeys[key] || key;

        return {[newKey]: obj[key]};
    });

    return Object.assign({}, ...entries);
}

export function timestamp() {
    return Math.floor(Date.now() / 1000);
}

export function timeSince(seconds, format = "YYYY/MM/DD") {

    let now = new persianDate.unix(timestamp());
    now.hours(0).minutes(0).seconds(0);
    let targetPersianDate = new persianDate.unix(seconds);
    targetPersianDate.hours(0).minutes(0).seconds(0);
    const daysDifference = targetPersianDate.diff(now, 'days'); // 86400000

    switch (daysDifference) {
        case -2:
            return "پریروز";
        case -1:
            return "دیروز";
        case 0:
            return "امروز";
        case 1:
            return "فردا";
        case 2:
            return "پسفردا";
        default:return targetPersianDate.format(format);
    }

}

export function timestampToDate(seconds, format = "YYYY/MM/DD"){
    return new persianDate.unix(seconds).format(format);
}

export function dateToPersian(date, format = "YYYY/MM/DD", calendar = "persian", locale="fa"){
    return new persianDate(new Date(date)).toCalendar(calendar).toLocale(locale).format(format);
}
export function subtractDateToPersian(date, unit, value, format = "YYYY/MM/DD", calendar = "persian", locale="fa"){
    return new persianDate(new Date(date)).subtract(unit, value).toCalendar(calendar).toLocale(locale).format(format);
}

export const copyToClipboard = async(text, toast, message) => {

    toast.current.show({severity: 'success', content: message, life: 2000, closable:false });

    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
    } else {
        return document.execCommand('copy', true, text);
    }


};

export function removeDuplicateObjects(arr, prop) {
    return arr.filter((obj, index, array) => {
        return array.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === index;
    });
}

export function extractUUIDFromUrl(url) {
    // Regular expression to match UUID format
    const uuidRegex = /[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/;

    // Extract UUID using the regex
    const match = url.match(uuidRegex);

    // Check if a match was found
    if (match && match.length > 0) {
        return match[0];
    } else {
        // Return null or handle the case where UUID is not found
        return null;
    }
}

export const imageToBase64 = async (file, callback) => {

    if (file){
        const reader = new FileReader();

        reader.onload = () => {

            let base64String = btoa(reader.result);
            callback(base64String);
        };

        reader.readAsBinaryString(file);
    }
}

export function ticketSeverity(code){
    switch (code) {
        case 0: return "header-warning-gradient text-yellow-500";
        case 1: return "header-plain-gradient";
        case 2: return "header-danger-gradient text-red-500";
        default: return "header-plain-gradient";
    }
}

export function farsiDigitsToInt(inputString) {
    // Define a mapping of Farsi digits to Western digits
    const farsiToWesternDigits = {
        '۰': '0',
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
    };

    // Replace Farsi digits with Western digits
    const westernDigitsString = inputString.replace(/[۰-۹]/g, match => farsiToWesternDigits[match]);

    // Parse the string as an integer
    return parseInt(westernDigitsString, 10);
}

export function isDesktop() {
    return window.innerWidth >= 992;
}

export function downloadBase64AsExcel(base64String, fileName) {
    // Convert the Base64 string to a Blob
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Create a download link
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;

    // Trigger a click event to start the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}











